import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import classNames from 'classnames';
import { ComponentProps, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { ButtonPrimary, Callout, LoadingSpinerArea, DesignSystemSpecialModal as Modal } from '../../../../../components';
import { channelsConfigSchema, ChannelsConfigSchema, initialState, selectorSetupIpaChannels } from '../../../../../reducers/reducerIPA/channels';
import { mutateSetupIpaChannels } from './services';
import styles from './SetupIpaChannels.module.scss';
import { SetupOfferForm } from './SetupOfferForm';
import { SetupWholesaleForm } from './SetupWholesaleForm';

const SetupIpaChannels = ({ className, ...props }: ComponentProps<'form'>) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const userChannelsData = useSelector(selectorSetupIpaChannels);

  const form = useForm<ChannelsConfigSchema>({
    resolver: zodResolver(channelsConfigSchema),
    values: userChannelsData || initialState,
  });

  const { mutateAsync, isLoading } = useMutation(mutateSetupIpaChannels());

  const handleSubmit = async (formData: ChannelsConfigSchema) => {
    if (userChannelsData.offer.enabled && !formData.offer.enabled) {
      setIsConfirmationModalOpen(true);
      return;
    }

    await mutateAsync(formData);
  };

  const handleCloseConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  const handleSubmitConfirmationModal = async (formData: ChannelsConfigSchema) => {
    await mutateAsync(formData);
    handleCloseConfirmationModal();
  };

  return (
    <>
      <form className={classNames(styles.form, className)} onSubmit={form.handleSubmit(handleSubmit)} {...props}>
        <SetupWholesaleForm form={form} />

        <SetupOfferForm form={form} />

        <div>
          <Callout size="sm">
            As modificações realizadas até as 22h serão aplicadas na próxima integração de dados. Após esse horário, elas refletem na integração do dia
            seguinte.
          </Callout>
        </div>

        <div className={styles.footer}>
          <ButtonPrimary type="reset" theme="ghost" onClick={() => form.reset()}>
            cancelar
          </ButtonPrimary>
          <ButtonPrimary type="submit">salvar</ButtonPrimary>
        </div>

        <LoadingSpinerArea />
      </form>
      <Modal.Root show={isConfirmationModalOpen} onHide={handleCloseConfirmationModal}>
        <Modal.Header>
          <Modal.Icon icon="Loader2" />
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>Atenção!</Modal.Title>
          <Modal.Content>
            Você possui regras de preço de oferta criadas. Ao desabilitar o uso de preço de oferta no IPA, essas regras serão inativadas.
          </Modal.Content>
        </Modal.Body>
        <Modal.Footer>
          <ButtonPrimary theme="ghost" onClick={handleCloseConfirmationModal}>
            cancelar
          </ButtonPrimary>
          <ButtonPrimary type="submit" onClick={form.handleSubmit(handleSubmitConfirmationModal)} isLoading={isLoading}>
            salvar mesmo assim
          </ButtonPrimary>
        </Modal.Footer>
      </Modal.Root>
    </>
  );
};

export default SetupIpaChannels;
